import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getBreakoutTopic, getFeedCategories } from "../services/news-feed.services";
import { setFeedCategoriesData, setBreakCategoriesData } from "context/features/dataSlice";

const fetchingRef = { categories: false, breakout: false };

export const useGetFeedCategories = () => {
  const { user } = useSelector((state) => state.auth);
  const { feedCategoriesData, breakCategoriesData } = useSelector((state) => state.data);
  const dispatch = useDispatch();
  const [feedCategories, setFeedCategories] = useState(feedCategoriesData || []);
  const [breakCategories, setBreakOutCategories] = useState(breakCategoriesData || []);

  const fetchCategories = async () => {
    if (fetchingRef.categories || feedCategoriesData?.length > 0) return;
    fetchingRef.categories = true;
    try {
      const categories = await getFeedCategories(user.userId);
      setFeedCategories(categories);
      dispatch(setFeedCategoriesData(categories));
    } catch (error) {
      console.error("Failed to fetch feed categories:", error);
    } finally {
      fetchingRef.categories = false;
    }
  };

  const fetchBreakoutTopics = async () => {
    if (fetchingRef.breakout || breakCategoriesData?.length > 0) return;
    fetchingRef.breakout = true;
    try {
      const categories = await getBreakoutTopic(user.userId);
      setBreakOutCategories(categories);
      dispatch(setBreakCategoriesData(categories));
    } catch (error) {
      console.error("Failed to breakout topic list", error);
    } finally {
      fetchingRef.breakout = false;
    }
  };

  useEffect(() => {
    if (feedCategoriesData?.length > 0) {
      setFeedCategories(feedCategoriesData);
    } else {
      fetchCategories();
    }
    if (breakCategoriesData?.length > 0) {
      setBreakOutCategories(breakCategoriesData);
    } else {
      fetchBreakoutTopics();
    }
  }, []);

  return { feedCategories, breakCategories };
};
